import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
//primereact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
//components
import ModalPayment from "./ModalPayment";
import ModalSigners from "./ModalSigners";
import ModalPixPayment from "../../../components/payment/ModalPixPayment";
import ModalActivationPlan from "./ActivationPlan/ModalActivationPlan";
//context
import { useAppContext } from "../../../context/AppContext";
import { useRegisterCompletedContext } from "./RegisterCompletedContext";
//assets
import checkedIcon from "../../../assets/images/checked.svg";
//services
import { getPixGenerate } from "../../../services/CreateAccount/getPixGenerate";
import { getStatusPayment } from "../../../services/CreateAccount/getStatusPayment";
//utils
import { logout } from "../../../utils/auth";

const RegisterCompleted = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const divRef = useRef(null);
  const [divHeight, setDivHeight] = useState("100vh");
  const [enabledQuery, setEnabledQuery] = useState(true);
  const [visibleEmail, setvisibleEmail] = useState(false);
  const [pixPayment, setPixPayment] = useState(
    state?.pixPayment ? state.pixPayment : false
  );
  const [pixCompleted, setPixCompleted] = useState(false);
  const [pixDataQR, setPixDataQR] = useState(null);
  const [visiblePixPayment, setVisiblePixPayment] = useState(false);
  const {
    handleSetAppSidebarNone,
    handleSetAppHeaderNone,
    handleSetAppContentClass,
  } = useAppContext();
  const {
    plan,
    paymentId,
    activePlan,
    visiblePaymentModal,
    setVisiblePaymentModal,
    visibleActivationModal,
    setVisibleActivationModal,
  } = useRegisterCompletedContext();
  const { data: statusPayment } = useQuery({
    queryKey: ["statusPayment"],
    queryFn: () =>
      getStatusPayment(
        state?.idPayment ? state?.idPayment : paymentId ? paymentId : ""
      ),
    refetchInterval: 20000,
    onSuccess: () => {
      if (
        statusPayment?.payment.status === 1 &&
        testSigners(statusPayment?.contract.signatures)
      ) {
        setEnabledQuery(false);

        setTimeout(() => {
          logout();
          navigate("/");
        }, 5000);
      }
    },
    enabled: !!((enabledQuery && state?.idPayment) || paymentId !== undefined),
  });

  // console.log(statusPayment);

  const testSigners = (signers) => {
    if (signers) {
      return signers.every((signer) => signer.status === "signed");
    }
  };

  const handleClickPix = async () => {
    const notification = toast.loading("Gerando seu código PIX");
    try {
      const response = await getPixGenerate(
        state?.idPayment ? state?.idPayment : ""
      );
      // console.log(response);
      setPixDataQR({
        id: response.payment_id,
        copy: response.pix,
        qr_code: response.link_QRcode,
        timer: 7,
      });
      setVisiblePixPayment(true);
      toast.update(notification, {
        render: "Código pix gerado",
        autoClose: 2000,
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro a gerar código PIX",
        autoClose: 3000,
        type: "error",
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    handleSetAppSidebarNone(true);
    handleSetAppHeaderNone(true);
    handleSetAppContentClass("p-0");

    const updateDivHeight = () => {
      if (divRef.current) {
        const divHeightPx = divRef.current.scrollHeight;
        const viewportHeightPx = window.innerHeight;

        if (divHeightPx > viewportHeightPx) {
          setDivHeight("100%");
        } else {
          setDivHeight("100vh");
        }
      }
    };

    updateDivHeight();
    window.addEventListener("resize", updateDivHeight);

    return () => {
      window.removeEventListener("resize", updateDivHeight);
      handleSetAppSidebarNone(false);
      handleSetAppHeaderNone(false);
      handleSetAppContentClass("");
    };
  }, []);

  return (
    <>
      <div
        ref={divRef}
        style={{ height: divHeight }}
        className="bg-white p-5 d-flex justify-content-center align-items-center"
      >
        <div className="text-center justify-content-center">
          <img
            src={checkedIcon}
            alt="Checked"
            style={
              window.innerWidth <= 992
                ? { width: "10rem", height: "10rem" }
                : { width: "15rem", height: "15rem" }
            }
          />
          {/* <h1
          style={
            window.innerWidth <= 992
              ? { fontSize: "10rem" }
              : { fontSize: "15rem" }
          }
        >
          <i className="fa-solid fa-circle-check text-success"></i>
        </h1> */}
          <h1
            style={
              window.innerWidth <= 992
                ? { fontSize: "2rem" }
                : { fontSize: "3rem" }
            }
          >
            Estamos quase lá!
          </h1>
          <h4
            className={`${
              window.innerWidth <= 992 ? "mt-3 mb-5" : "mt-3 mb-4"
            }`}
          >
            {state?.activation
              ? "Vamo ativar sua conta! Para ativar sua conta siga as seguintes instruções:"
              : "Sua conta foi criada! Para ter acesso ao sistema siga as seguintes instruções:"}
          </h4>
          <div
            className={`d-flex flex-column ${
              window.innerWidth >= 992 && "col-10 mx-auto"
            }`}
          >
            {state?.activation ? (
              <>
                <div className="row my-4 align-items-center">
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-2" : "col-1"
                    } d-flex justify-content-center`}
                  >
                    {/* <div
                      className="pt-2"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "2.2rem",
                        height: "2.2rem",
                        borderRadius: "50%",
                        textAlign: "center",
                      }}
                    >
                      <h1
                        style={
                          window.innerWidth <= 992
                            ? { fontSize: "2.2rem" }
                            : { fontSize: "2.2rem" }
                        }
                      >
                        <i className="fa-solid fa-circle-check text-success"></i>
                      </h1>
                    </div> */}
                    {activePlan ? (
                      <div
                        className="pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={
                            window.innerWidth <= 992
                              ? { fontSize: "2.2rem" }
                              : { fontSize: "2.2rem" }
                          }
                        >
                          <i className="fa-solid fa-circle-check text-success"></i>
                        </h1>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          border: "2px solid black",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h2 style={{ margin: 0 }}>1</h2>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-10" : "col-11"
                    } text-start`}
                  >
                    <h5>
                      Selecione o plano desejado e a forma de pagamento para
                      utilizar no Lote Mobile.{" "}
                      {!activePlan && (
                        <span
                          className="text-success"
                          style={{ cursor: "pointer" }}
                          onClick={() => setVisibleActivationModal(true)}
                        >
                          Clique aqui para selecionar
                        </span>
                      )}
                    </h5>
                  </div>
                </div>
                <div className="row my-4 align-items-center">
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-2" : "col-1"
                    } d-flex justify-content-center`}
                  >
                    {testSigners(statusPayment?.contract.signatures) ? (
                      <div
                        className="pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={
                            window.innerWidth <= 992
                              ? { fontSize: "2.2rem" }
                              : { fontSize: "2.2rem" }
                          }
                        >
                          <i className="fa-solid fa-circle-check text-success"></i>
                        </h1>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          border: "2px solid black",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h2 style={{ margin: 0 }}>2</h2>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-10" : "col-11"
                    } text-start`}
                  >
                    <h5>
                      Verifique o e-mail que foi enviado para os sócios da
                      empresa e assine o contrato recebido para liberar o acesso{" "}
                      {typeof statusPayment?.contract === "object" && (
                        <>
                          {statusPayment?.contract.signatures.length > 0 && (
                            <span
                              className="text-success"
                              style={{ cursor: "pointer" }}
                              onClick={() => setvisibleEmail(true)}
                            >
                              Clique aqui para ver o andamento
                            </span>
                          )}
                        </>
                      )}
                    </h5>
                  </div>
                </div>
                <div className="row my-4 align-items-center">
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-2" : "col-1"
                    } d-flex justify-content-center`}
                  >
                    {(pixPayment && pixCompleted) ||
                    statusPayment?.payment.status === 1 ? (
                      <div
                        className="pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={
                            window.innerWidth <= 992
                              ? { fontSize: "2.2rem" }
                              : { fontSize: "2.2rem" }
                          }
                        >
                          <i className="fa-solid fa-circle-check text-success"></i>
                        </h1>
                      </div>
                    ) : statusPayment?.payment.status === 2 ||
                      statusPayment?.environment_status === 4 ? (
                      <>
                        <div
                          className="pt-2 error-payment"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "2.2rem",
                            height: "2.2rem",
                            borderRadius: "50%",
                            textAlign: "center",
                            cursor: "help",
                          }}
                          data-pr-tooltip="Ocorreu um erro ao processar o pagamento. Por favor, tente novamente."
                          data-pr-position="top"
                        >
                          <h1
                            style={
                              window.innerWidth <= 992
                                ? { fontSize: "2.2rem" }
                                : { fontSize: "2.2rem" }
                            }
                          >
                            <i className="fa-solid fa-circle-xmark text-danger"></i>
                          </h1>
                        </div>
                        <Tooltip target=".pt-2" />
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          border: "2px solid black",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h2 style={{ margin: 0 }}>3</h2>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-10" : "col-11"
                    } text-start d-flex`}
                  >
                    <div className="col-md-11">
                      <h5>
                        Verificação, análise completa dos dados de pagamento e
                        confirmação de pagamento,{" "}
                        {(statusPayment?.payment.status === 2 ||
                          statusPayment?.environment_status === 4) && (
                          <span
                            className="text-success"
                            style={{ cursor: "pointer" }}
                            onClick={() => setVisiblePaymentModal(true)}
                          >
                            Clique aqui para corrigir
                          </span>
                        )}
                        {pixPayment && !pixCompleted && (
                          <span
                            className="text-success"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClickPix()}
                          >
                            Clique aqui para efetuar o pagamento pix
                          </span>
                        )}
                      </h5>
                    </div>
                    {/* {statusPayment?.payment.status === 2 && (
                <div className="col-md-1">
                  <Button
                    className={"w-100"}
                    icon="fa-solid fa-eye"
                    tooltip="analisar pagamento"
                    tooltipOptions={{ position: "top" }}
                    onClick={() => setVisiblePaymentModal(true)}
                  />
                </div>
              )} */}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row my-4 align-items-center">
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-2" : "col-1"
                    } d-flex justify-content-center`}
                  >
                    <div
                      className="pt-2"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "2.2rem",
                        height: "2.2rem",
                        borderRadius: "50%",
                        textAlign: "center",
                      }}
                    >
                      <h1
                        style={
                          window.innerWidth <= 992
                            ? { fontSize: "2.2rem" }
                            : { fontSize: "2.2rem" }
                        }
                      >
                        <i className="fa-solid fa-circle-check text-success"></i>
                      </h1>
                    </div>
                    {/* <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "2.2rem",
                  height: "2.2rem",
                  border: "2px solid black",
                  borderRadius: "50%",
                  textAlign: "center",
                }}
              >
                <h2 style={{ margin: 0 }}>1</h2>
              </div> */}
                  </div>
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-10" : "col-11"
                    } text-start`}
                  >
                    <h5>
                      Preenchimento e validação dos dados para criação da sua
                      conta Lote Mobile
                    </h5>
                  </div>
                </div>
                <div className="row my-4 align-items-center">
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-2" : "col-1"
                    } d-flex justify-content-center`}
                  >
                    {testSigners(statusPayment?.contract.signatures) ? (
                      <div
                        className="pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={
                            window.innerWidth <= 992
                              ? { fontSize: "2.2rem" }
                              : { fontSize: "2.2rem" }
                          }
                        >
                          <i className="fa-solid fa-circle-check text-success"></i>
                        </h1>
                      </div>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          border: "2px solid black",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h2 style={{ margin: 0 }}>2</h2>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-10" : "col-11"
                    } text-start`}
                  >
                    <h5>
                      Verifique o e-mail que foi enviado para os sócios da
                      empresa e assine o contrato recebido para liberar o acesso{" "}
                      {typeof statusPayment?.contract === "object" && (
                        <>
                          {statusPayment?.contract.signatures.length > 0 && (
                            <span
                              className="text-success"
                              style={{ cursor: "pointer" }}
                              onClick={() => setvisibleEmail(true)}
                            >
                              Clique aqui para ver o andamento
                            </span>
                          )}
                        </>
                      )}
                    </h5>
                  </div>
                </div>
                <div className="row my-4 align-items-center">
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-2" : "col-1"
                    } d-flex justify-content-center`}
                  >
                    {(pixPayment && pixCompleted) ||
                    statusPayment?.payment.status === 1 ? (
                      <div
                        className="pt-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={
                            window.innerWidth <= 992
                              ? { fontSize: "2.2rem" }
                              : { fontSize: "2.2rem" }
                          }
                        >
                          <i className="fa-solid fa-circle-check text-success"></i>
                        </h1>
                      </div>
                    ) : statusPayment?.payment.status === 2 ||
                      statusPayment?.environment_status === 4 ? (
                      <>
                        <div
                          className="pt-2 error-payment"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "2.2rem",
                            height: "2.2rem",
                            borderRadius: "50%",
                            textAlign: "center",
                            cursor: "help",
                          }}
                          data-pr-tooltip="Ocorreu um erro ao processar o pagamento. Por favor, tente novamente."
                          data-pr-position="top"
                        >
                          <h1
                            style={
                              window.innerWidth <= 992
                                ? { fontSize: "2.2rem" }
                                : { fontSize: "2.2rem" }
                            }
                          >
                            <i className="fa-solid fa-circle-xmark text-danger"></i>
                          </h1>
                        </div>
                        <Tooltip target=".pt-2" />
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "2.2rem",
                          height: "2.2rem",
                          border: "2px solid black",
                          borderRadius: "50%",
                          textAlign: "center",
                        }}
                      >
                        <h2 style={{ margin: 0 }}>3</h2>
                      </div>
                    )}
                  </div>
                  <div
                    className={`${
                      window.innerWidth <= 992 ? "col-10" : "col-11"
                    } text-start d-flex`}
                  >
                    <div className="col-md-11">
                      <h5>
                        Verificação, análise completa dos dados de pagamento e
                        confirmação de pagamento,{" "}
                        {(statusPayment?.payment.status === 2 ||
                          statusPayment?.environment_status === 4) && (
                          <span
                            className="text-success"
                            style={{ cursor: "pointer" }}
                            onClick={() => setVisiblePaymentModal(true)}
                          >
                            Clique aqui para corrigir
                          </span>
                        )}
                        {pixPayment && !pixCompleted && (
                          <span
                            className="text-success"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClickPix()}
                          >
                            Clique aqui para efetuar o pagamento pix
                          </span>
                        )}
                      </h5>
                    </div>
                    {/* {statusPayment?.payment.status === 2 && (
                <div className="col-md-1">
                  <Button
                    className={"w-100"}
                    icon="fa-solid fa-eye"
                    tooltip="analisar pagamento"
                    tooltipOptions={{ position: "top" }}
                    onClick={() => setvisiblePayment(true)}
                  />
                </div>
              )} */}
                  </div>
                </div>
              </>
            )}
            <div className="row my-4 align-items-center">
              {/* <div
              className={`${
                window.innerWidth <= 992 ? "col-2" : "col-1"
              } d-flex justify-content-center`}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "2.2rem",
                  height: "2.2rem",
                  border: "2px solid black",
                  borderRadius: "50%",
                  textAlign: "center",
                }}
              >
                <h2 style={{ margin: 0 }}>4</h2>
              </div>
            </div> */}
              <div
                className={`${
                  window.innerWidth <= 992 ? "col-12" : "col-12"
                } text-center`}
              >
                <h5>
                  Após completar os procedimentos anteriores, seu acesso ao
                  sistema vai estar liberado!
                </h5>
              </div>
            </div>
          </div>
          <div className={`${window.innerWidth <= 992 ? "mt-5" : "mt-3"}`}>
            {statusPayment?.payment.status === 1 &&
              testSigners(statusPayment?.contract.signatures) && (
                <Button
                  rounded
                  label="Fazer Login"
                  className={`${
                    window.innerWidth <= 992 ? "w-100" : "w-50"
                  } border border-0`}
                  onClick={() => navigate("/")}
                />
              )}
          </div>
        </div>
      </div>
      <ModalPayment
        visible={visiblePaymentModal}
        setVisible={setVisiblePaymentModal}
        plan={state?.plan ?? plan}
      />
      <ModalActivationPlan
        visible={visibleActivationModal}
        setVisible={setVisibleActivationModal}
      />
      <ModalPixPayment
        visible={visiblePixPayment}
        setVisible={setVisiblePixPayment}
        pixDataQR={pixDataQR}
        setPixDataQR={setPixDataQR}
        onContinue={() =>
          navigate("/success", {
            state: {
              pixPayment: true,
              idPayment: pixDataQR.id ? pixDataQR.id : "",
            },
          })
        }
      />
      <ModalSigners
        visible={visibleEmail}
        setVisible={setvisibleEmail}
        signers={statusPayment?.contract.signatures}
      />
    </>
  );
};

export default RegisterCompleted;
